import { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { useGetUserQuery } from "../../services/usersApi";
import { useToast } from "../../hooks/useToast.ts";
import { InputNumber } from 'primereact/inputnumber';
import { useCreateViewMutation } from '../../services/viewsApi.js';
import UserDropdown from '../UserDropdown';


const ProjectModal = ({
    project,
    visible,
    onHide,
    onSubmit,
    visibleTasks,
    allTasks = [],
    usersData = [],
    institutionsData = []

}) => {
    const [editedProject, setEditedProject] = useState(project || {
        name: '',
        description: ''
    });

    const [workHours, setWorkHours] = useState(0);
    const [createView] = useCreateViewMutation();
    const { data: user, isLoading } = useGetUserQuery();
    const toast = useToast();

    const statusOptions = [
        { label: 'Bieżące', value: 'active' },
        { label: 'Archiwum', value: 'closed' },
        { label: 'Oferty', value: 'open' }
    ];




    useEffect(() => {
        if (project) {
            setEditedProject(project);
        }

        if (allTasks && project) {
            setWorkHours(0);
            let newTasks = allTasks.filter((task) => task.project === project.id)

            let sumWorkHours = 0;

            for (let i = 0; i < newTasks.length; i++) {
                sumWorkHours += newTasks[i].workHours
            }

            setWorkHours(sumWorkHours)
        }
    }, [project, allTasks]);

    const handleInputChange = (e, field) => {
        setEditedProject({ ...editedProject, [field]: e.target.value });
    };

    const handleSubmit = () => {
        // Walidacja nazwy projektu
        if (!editedProject.name || editedProject.name.trim() === '') {
            toast("Nazwa projektu jest wymagana", "error");
            return;
        }
        
        onSubmit(editedProject);
        onHide();
        setWorkHours(0);
    };

    const handleHide = () => {
        setWorkHours(0);
        onHide();
    }

    const handleAddView = async () => {
        const projectsTasks = visibleTasks.filter((t) => t.project === project.id || t.id === project.id)
        let modifiedTasks = projectsTasks.map(({ id, progress, hide, hideChildren, project, ...rest }) => {
            const newObj = { ...rest };
            if (newObj.type === "project") {
                delete newObj.displayOrder;
            }
            if (newObj.dependencies) {
                if (newObj?.dependencies[0]?.length) {
                    newObj.dependencies = [projectsTasks.findIndex((t) => t.id === newObj.dependencies[0])]
                }
            }


            return newObj;
        });

        const baseTime = projectsTasks[0].start;
        modifiedTasks = modifiedTasks.map((obj) => {
            const StartBased = obj.start - baseTime;
            const EndBased = obj.end - baseTime;
            delete obj._id;
            delete obj.id
            return { ...obj, start: StartBased, end: EndBased }
        })

        try {
            const newView = {
                name: project.name,
                items: JSON.stringify(modifiedTasks)
            }
            await createView(newView).unwrap();

            toast(`widok "${project.name}" został utworzony`, "success");
        } catch (err) {
            toast(`Błąd podczas tworzenia zadania: "${err.message}"`, "error");
        }
    }

    const footer = (
        <div>
            <Button
                label="Anuluj"
                icon="pi pi-times"
                onClick={handleHide}
                className="p-button-secondary"
            />
            {!isLoading && user && (
                user.type === "admin" || 
                (user.type === "manager" && (!editedProject._id || editedProject.coordinators?.includes(user._id)))
            ) && (
                <Button
                    label="Zapisz"
                    icon="pi pi-check"
                    onClick={handleSubmit}
                    className="p-button-primary"
                />
            )}
        </div>
    );

    return (
        <Dialog
            header={editedProject._id ? `Edycja grupy: ${editedProject.name || ''}` : 'Nowy projekt'}
            visible={visible}
            style={{ width: '50vw' }}
            onHide={handleHide}
            footer={footer}
            breakpoints={{ '960px': '75vw', '640px': '90vw' }}
            className="project-modal"
        >
            <div className="p-fluid">
                <div className="p-field mb-3">
                    <label htmlFor="name">Nazwa grupy <span style={{ color: 'red' }}>*</span></label>
                    <InputText
                        disabled={isLoading || !user || !(user.type === "admin" || (user.type === "manager" && (!editedProject._id || editedProject.coordinators?.includes(user._id))))}
                        id="name"
                        value={editedProject.name}
                        onChange={(e) => handleInputChange(e, 'name')}
                        required
                        autoFocus
                        placeholder="Wprowadź nazwę projektu"
                    />
                </div>

                <div className="p-field mb-3">
                    <label htmlFor="description">Opis grupy</label>
                    <InputTextarea
                        disabled={isLoading || !user || !(user.type === "admin" || (user.type === "manager" && (!editedProject._id || editedProject.coordinators?.includes(user._id))))}
                        id="description"
                        value={editedProject.description}
                        onChange={(e) => handleInputChange(e, 'description')}
                        rows={5}
                        autoResize
                    />
                </div>

                <div className="p-field mb-3">
                    <UserDropdown
                        selectedUser={editedProject.coordinators || []}
                        onUserSelect={(e) => setEditedProject({ ...editedProject, coordinators: e.value })}
                        usersData={usersData}
                        institutionsData={institutionsData}
                        floating={false}
                        label="Koordynatorzy"
                        userTypes={["admin", "manager"]}
                        disabled={isLoading || !user || !(user.type === "admin" || (user.type === "manager" && (!editedProject._id || editedProject.coordinators?.includes(user._id))))}
                    />
                </div>

                <div className="p-field mb-3">
                    <label htmlFor="status">Status projektu</label>
                    <Dropdown
                        disabled={isLoading || !user || !(user.type === "admin" || (user.type === "manager" && (!editedProject._id || editedProject.coordinators?.includes(user._id))))}
                        id="status"
                        value={editedProject.status || 'open'}
                        options={statusOptions}
                        onChange={(e) => setEditedProject({ ...editedProject, status: e.value })}
                        placeholder="Wybierz status"
                    />
                </div>

                <div className="p-field mb-3">
                    <label htmlFor="description">Roboczogodziny</label>
                    <InputNumber value={workHours} disabled locale="de-DE" />
                </div>

                <div className="p-d-flex p-jc-between p-mt-4">
                    {!isLoading && user && editedProject._id && (
                        user.type === "admin" || 
                        (user.type === "manager" && editedProject.coordinators?.includes(user._id))
                    ) && (
                        <Button
                            label="Zapisz grupę"
                            icon="pi pi-save"
                            className="p-button-sm p-button-info mb-3"
                            onClick={handleAddView}
                        />
                    )}
                </div>
            </div>
        </Dialog>
    );
};

export default ProjectModal;